<div
  class="markdown-content"
  *ngIf="content"
  [innerHtml]="content | marked"
></div>
